module.exports = __webpack_public_path__ + "static/media/no-money.39f438a8.svg";